/**
 * 「既選択除外」候補算出の共通 helper。
 *
 * 複数行 fieldArray で「他行が選択済みの ID を候補リストから除外しつつ、
 * 当該行で既選択の ID はリストに残す」パターンを共通化する。
 *
 * PlanMasterBgsSection / SuppressionPartnerBgsSection / PlanMasterCodesSection で使用。
 */

/**
 * 全候補 `all` から usedIds を除外しつつ、currentId が usedIds に含まれていても残す。
 *
 * @param all - 全候補一覧 (id: string を持つオブジェクトの配列)
 * @param usedIds - 他行で使用済みの id セット (この行の id は含まない)
 * @param currentId - この行で現在選択している id (usedIds に含まれていても候補に残す)
 */
export function availableOptions<T extends { id: string }>(
  all: T[],
  usedIds: ReadonlySet<string>,
  currentId: string,
): T[] {
  return all.filter((o) => !usedIds.has(o.id) || o.id === currentId)
}
